module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_12-c0343f0680fddfe53ebe51518528e3a7.jpg";